module.exports = __webpack_public_path__ + "static/media/logo_lgl_schriftzug.1a781798.png";